import React from 'react';
import ProductList from './ProductList';
import CategoryList from './CategoryList';
import { products } from '../products';
import '../css/HomePage.css';

const HomePage = () => {
    return (
        <div className="homepage">
            <section 
                className="hero-section"
                style={{
                    backgroundImage: 'url("/images/bg.PNG")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    boxShadow: '0 6px 25px rgba(248, 249, 249, 0.4)'
                }}
            >
                <div className="hero-overlay"></div>
                <div className="hero-content">
                    <h1>Welcome to PotCityDC</h1>
                    <p>Discover premium cannabis products</p>
                </div>
            </section>

            {/* Categories Section */}
            <section className="categories-section">
                <CategoryList />
            </section>

            {/* Products Section with ID for navigation */}
            <section id="products-section" className="products-section">
                <div className="section-header">
                    <h2>Featured Products</h2>
                    <p>Explore our curated selection</p>
                </div>
                <ProductList products={products.slice(0, 100)} />
            </section>
        </div>
    );
};

export default HomePage;